import React from "react";

const TravelPartnersProgram = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}






<section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Travel Partners Program</h1>
          </div>
        </div>
      </section>


     

      {/* ===== MAIN CONTENT SECTION ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="/images/gallery/09.jpeg"
                alt="Travel Partners Program with Pune Corporate Cars"
                className="img-fluid rounded shadow-lg"
              />
            </div>

            {/* CONTENT */}
            <div className="col-lg-6">
              <h2 className="mb-3">
                <span className="text-danger">Travel</span> Partners Program
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. invites travel agencies,
                tour operators, event planners, hotels, and corporate
                facilitators to join our Travel Partners Program — a
                collaborative ecosystem designed to deliver seamless,
                reliable, and premium ground transportation solutions.
              </p>

              <p>
                As a trusted corporate mobility provider, we support our
                partners with a well-maintained fleet, professional
                chauffeurs, centralized operations, and scalable transport
                capabilities across Pune and major Indian cities.
              </p>

              <p>
                Whether you manage corporate travel, MICE events,
                destination weddings, or inbound delegations, our
                partnership model ensures operational efficiency,
                service consistency, and long-term revenue growth.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== WHY PARTNER WITH US ===== */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Why Partner with Pune Corporate Cars?</h2>
              <p className="text-muted">
                A dependable mobility partner trusted by corporates,
                hotels, event companies, and government institutions.
              </p>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Strategic business collaboration & referrals</li>
                <li className="mb-3">✔ Access to premium & corporate vehicle fleet</li>
                <li className="mb-3">✔ Dedicated account & operations support</li>
                <li className="mb-3">✔ Transparent pricing & billing systems</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Support for MICE, corporate & leisure travel</li>
                <li className="mb-3">✔ Pan-India scalability & execution capability</li>
                <li className="mb-3">✔ Reliable service-level commitments</li>
                <li className="mb-3">✔ Long-term partnership & growth opportunities</li>
              </ul>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default TravelPartnersProgram;
